import axios from "utils/APIv2";

export const getCash = async (params) => {
  const res = await axios.get(`/dashboard/cash`, { params });
  return res.data;
};

export const getOrders = async (params) => {
  const res = await axios.get(`/dashboard/order`, { params });
  return res.data;
};

export const getPayables = async (params) => {
  const res = await axios.get(`/dashboard/payable`, { params });
  return res.data;
};
export const getReceivables = async (params) => {
  const res = await axios.get(`/dashboard/receivable`, { params });
  return res.data;
};
export const getCollections = async (params) => {
  const res = await axios.get(`/dashboard/collection`, { params });
  return res.data;
};

export const getReceivableForcast = async (params) => {
  const res = await axios.get(`/dashboard/receivable-forecast`, { params });
  return res.data;
};
export const getOrderForcast = async (params) => {
  const res = await axios.get(`/dashboard/order-forecast`, { params });
  return res.data;
};
export const getPayableForcast = async (params) => {
  const res = await axios.get(`/dashboard/payable-forecast`, { params });
  return res.data;
};
export const getCashForcast = async (params) => {
  const res = await axios.get(`/dashboard/cash-forecast`, { params });
  return res.data;
};

export const getDaysSalesOutstanding = async (params) => {
  const res = await axios.get(`/dashboard/days-sales-outstanding`, { params });
  return res.data;
};
export const getDaysPayablesOutstanding = async (params) => {
  const res = await axios.get(`/dashboard/days-payables-outstanding`, { params });
  return res.data;
};

export const getNetCashGraph = async (params) => {
  const res = await axios.get(`/dashboard/netcash/graph`, { params });
  return res.data;
};

export const getPaymentTermsPayables = async (params) => {
  const res = await axios.get(`/dashboard/payment-term-payable`, { params });
  return res.data;
};
export const getPaymentTermsReceivables = async (params) => {
  const res = await axios.get(`/dashboard/payment-term-receivable`, { params });
  return res.data;
};

export const getTopCustomersHighestOutstanding = async (params) => {
  const res = await axios.get(`/dashboard/top-customer-highest-outstanding`, { params });
  return res.data;
};
export const getTopCustomersHighestOrder = async (params) => {
  const res = await axios.get(`/dashboard/top-customer-highest-order`, { params });
  return res.data;
};
export const getTopSuppliersHighestOutstanding = async (params) => {
  const res = await axios.get(`/dashboard/top-supplier-highest-outstanding`, { params });
  return res.data;
};
export const getTopSuppliersHighestOrder = async (params) => {
  const res = await axios.get(`/dashboard/top-supplier-highest-order`, { params });
  return res.data;
};
export const getReceivablesAging = async (params) => {
  const res = await axios.get(`/dashboard/receivable-aging`, { params });
  return res.data;
};
export const getPayablesAging = async (params) => {
  const res = await axios.get(`/dashboard/payable-aging`, { params });
  return res.data;
};

export const getInsights = async (params) => {
  const res = await axios.get(`/dashboard/insights`, { params });
  return res.data.data;
};
export const getCollectionEffectiveness = async (params) => {
  const res = await axios.get(`/dashboard/collection-effectiveness`, { params });
  return res.data;
};
export const getPaymentProcessing = async (params) => {
  const res = await axios.get(`/dashboard/payment-processing`, { params });
  return res.data.data;
};
